import React, { Component } from 'react';
import { string } from 'prop-types';
import shave from 'shave';

import Link from '@blueberry/components/Link';

import { abbrivationFormat } from '@blueberry/utils/datetime';

import styles from './BannerContent.scss';

class BannerContent extends Component {
  static propTypes = {
    authorName: string.isRequired,
    describe: string.isRequired,
    publishDate: string.isRequired,
    title: string.isRequired,
    url: string.isRequired,
  };

  componentDidMount() {
    // shave only accpect number with max-height, 108 = 108px
    shave(`.${styles.titleText}`, 108, {
      spaces: false, // supports non-spaced languages (Non-ascii)
    });
  }

  render() {
    const { title, describe, publishDate, authorName, url } = this.props;

    return (
      <div className={styles.root}>
        <Link to={url} className={styles.link}>
          <h1 className={styles.title} title={title}>
            {title}
          </h1>
        </Link>

        <div className={styles.descr}>{describe}</div>
        <div className={styles.dateBlock}>
          <span>{authorName}</span>
          <span className={styles.dot} />
          <span>{abbrivationFormat(publishDate)}</span>
        </div>
      </div>
    );
  }
}

export default BannerContent;



// WEBPACK FOOTER //
// ./app/components/Banner/components/BannerContent/BannerContent.jsx